<template>
  <div class="day">
    <div class="day-header">
      <h4>{{ weekDay }} {{ weekMonth }}
        <span v-if="employees.length > 0" class="badge white pull-right">{{ employees.length }}</span>
      </h4>
      <p>
        <el-input placeholder="Buscar" v-model="search" @input="onChangeSearch()"></el-input>
        <el-button-group class="pull-right">
          <el-button size="mini"  @click="syncEmployees()" plain ><i class="fa fa-refresh"></i></el-button>
          <el-button size="mini"
                     :disabled="is_disable"
                     type="primary"
                     plain
                     v-if="canAdd()"
                     @click="saveAllDay()"><i class="fa fa-save"></i></el-button>
        </el-button-group>
      </p>
    </div>
    <div class="content" v-loading="loading">
      <el-alert
        v-if="error.message"
        :title="error.message"
        :closable="false"
        type="error">
      </el-alert>
      <employee v-for="item in employees"
                :key="item.uuid"
                :day="date"
                @employeeRemoved="onEmployeeRemoved"
                @employeeSaved="onEmployeeSaved"
                :cost_center_id="cost_center_id"
                :employee="item"></employee>
    </div>
  </div>
</template>

<script>
  import Employee from './Employee'
  import Permissions from '../../components/abstract/Permissions'
  import {baseApi} from '../../configs/urls'
  import * as moment from 'moment'
  import {params, parseError} from '../../packages/Helpers'
  const uuidv4 = require('uuid/v4')
  moment.locale('es')

  export default {
    name: 'week-day',
    extends: Permissions,
    components: {
      Employee: Employee
    },
    props: {
      date: Object,
      cost_center_id: Number,
      employee_list: Array,
      is_disable: Boolean
    },
    data () {
      return {
        weekDays: [
          'Domingo',
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado'
        ],
        checkinReport: [],
        search: '',
        employees: [],
        employees_all: [],
        loading: false,
        error: {},
        basePermission: 'checkin'
      }
    },
    computed: {
      weekDay () {
        return this.weekDays[this.date.day()]
      },
      weekMonth () {
        return this.date.format('D')
      }
    },
    methods: {
      syncEmployees () {
        this.loading = true
        const query = {
          date: this.date.format('YYYY-MM-DD'),
          cost_center_id: 0
        }

        if (this.cost_center_id) {
          query.cost_center_id = this.cost_center_id
        }
        this.error = {}
        this.$http.get(baseApi + '/checkins/employees' + params(query)).then(
          (response) => {
            this.loading = false
            this.checkinReport = response.data
            this.employees = response.data.map((item) => {
              item.uuid = uuidv4()
              return item
            })
            this.employees_all = [...this.employees]
          },
          (response) => {
            this.loading = false
            this.error = parseError(response, true)
          }
        )
      },
      copy (array) {
        return [...array].map((item) => {
          return {...item}
        })
      },
      copyEmployees () {
        return this.copy(this.employees)
      },
      saveAllDay () {
        if (!this.cost_center_id || this.employees.length === 0) {
          return
        }

        const invalids = this.copyEmployees().filter((employee) => {
          return !this.validNumberInput(employee.extra_hours, 0, 16) ||
            !this.validNumberInput(employee.double_hours, 0, 16) ||
            !this.validNumberInput(employee.worked_hours, 0, 8)
        })

        if (invalids.length > 0) {
          this.$message.error(
            this.date.format('YYYY-MM-DD') + ' Verifica que las Horas Dobles, Horas Extras u Horas Trabajadas sean validas.'
          )
          return
        }

        const employees = this.copyEmployees().map((employee) => {
          delete employee.uuid
          return employee
        })

        this.loading = true
        this.$http.post(baseApi + '/checkins/confirm-day', {
          date: this.date.format('YYYY-MM-DD'),
          cost_center_id: this.cost_center_id,
          employees: employees
        }).then(
          () => {
            this.syncEmployees()
            this.$message.success(
              'Se confirmado correctamente el dia ' + this.date.format('YYYY-MM-DD')
            )
          },
          (res) => {
            this.loading = false
            this.$message.error(parseError(res)[0])
          }
        )
      },

      validNumberInput (value, min, max) {
        return value >= min && value <= max
      },
      onEmployeeSaved (employee) {
        console.log('saved', employee)
        for (let i = 0; i < this.employees.length; i++) {
          if (this.employees[i].uuid === employee.uuid) {
            for (let key in employee) {
              if (employee.hasOwnProperty(key)) {
                this.employees[i][key] = employee[key]
              }
            }
            break
          }
        }
      },
      onEmployeeRemoved () {
        this.syncEmployees()
      },
      onChangeSearch () {
        if (this.search) {
          this.employees = this.copy(this.employees_all).filter((employee) => {
            return employee.name.toString().toLowerCase().includes(this.search.toLowerCase())
          })
        } else {
          this.employees = this.copy(this.employees_all)
        }
      }
    },
    mounted () {
      this.employees = [...this.employee_list]
      this.employees_all = [...this.employees]
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/checkins/Day.vue